<div class="container-fluid background-transparent pt-0">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
</div>

<div class="content-inner background-section">
  <div class="title-bar background-transparent">
    <a class="back-button mt-2 mb-4" (click)="emitData({key:'back'})"><img class="svg mr-2 ml-4 back-button"
        src="assets/ph-bhp-layout/svg/back.svg" /> {{ translationKeys.SOPObservation.Back | translate}}</a>
    <div class="container-fluid d-md-flex justify-content-between background-transparent">
      <h2 class="page-title">{{ "CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE" | translate}}</h2>
      <div>
        <lib-php-bhp-check-chart-export #exportTag [exportComponent]="compliance" [gridData]="gridData "
          [fields]="fields" [results]="results" [filters]="filters ? filters.toArray() : []" [kendoPDF]="compliance.pdf"
          [select]="'overallComplianceScore'" (childData)="emitData($event)" class="col p-0" [fileName]="pageTitle"
          [appName]="appName" [clickImageBtn]="clickImageBtn" [clickExcelBtn]="clickExcelBtn"
          [clickPdfBtn]="clickPdfBtn" [userData]="userData" (resetClickBtn)="resetExportAs($event)">
        </lib-php-bhp-check-chart-export>
      </div>
    </div>
  </div>
  <div>
    <div class="evaluation-section container-fluid reportFiter">
      <div class="row mt-4">
        <div class="col-md-6 col-sm-5">
          <div class="form-group multiselect-container">
            <div class="multiselect-top d-flex justify-content-between">
              <label>{{ "CHECK.EVALUATION.QUESTIONNAIRES" | translate }}</label>
              <button class="multiselect-clear" (click)="resetQuestionnaireFilter()">
                <img src="assets/icons/closeOutlined.svg" />
              </button>
            </div>
            <div class="multiselect-div">
              <kendo-multiselect #multiselect [data]="questionnaires" [(ngModel)]="selectedQuestionnaires"
                [textField]="'questionnaireName'" (valueChange)="onMultiselectChange($event)" [valueField]="'id'"
                [autoClose]="false" placeholder="{{ 'CHECK.EVALUATION.ALL_QUESTIONNAIRES' | translate }}">
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                  {{ dataItem.questionnaireName | labelSanitizer}}
                </ng-template>
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                  <div class="questionnaire-item">
                    <input type="checkbox" class="k-checkbox">
                    <span class="questionnaire-name">{{ dataItem.questionnaireName | labelSanitizer }}</span>
                    <span class="questionnaire-institution">{{ dataItem.institutionName | labelSanitizer }}</span>
                  </div>
                </ng-template>
              </kendo-multiselect>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-5">
          <div class="form-group">
            <div class="dropdown dropdown-bhp">
              <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                <input class="dropdown-toggle" type="text" [ngModel]="selectedQuestionType.name | translate" readonly />
                <span class="label-dropdown">{{ "CHECK.EVALUATION.QUESTION_TYPE" | translate}}</span>
                <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
              </div>
              <ul class="dropdown-menu">
                <li class="dropdown-item" (click)="onQuestionTypeChange(0)">{{ 'CHECK.EVALUATION.ALL_QUESTION_TYPES' |
                  translate }}</li>
                <li class="dropdown-item" *ngFor="let questionType of questionTypes"
                  (click)="onQuestionTypeChange(questionType)">{{ questionType.name | translate | labelSanitizer}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col my-3 d-flex  justify-content-end">
          <button class="btn-link-reset" (click)="resetFilters()" *ngIf=isDesktop>{{
            'EVALUATION.RESET_FILTERS' |
            translate }}</button>
        </div>
      </div>

      <ng-container *ngFor="let filterIndex of filterIndices; let i = index; trackBy: trackLoop">
        <lib-ph-bhp-filter #filter [filterIndex]="i" [userData]="appConfig.userData" [isDesktop]='isDesktop'
          [shouldShowRemoveButton]="filterIndex > 0" [evaluationLoaded]="evaluationLoaded"
          (filterRemoved)="onFilterRemoved(filterIndex)" [showProAndSubPro]="false"
          *ngIf="filterIndex === 0 || (filterIndex > 0 && showCompareCard)" (filterSaved)="onFilterSaved()"
          [userHasFilter]="userHasFilter">
        </lib-ph-bhp-filter>
      </ng-container>

      <div class="row">
        <div class="col my-3 justify-content-end d-flex">
          <div class="flex-container">
            <button *ngIf="isDesktop && filterIndices.length < 6" class="btn-cancel-bordered-bd"
              (click)="filterCompare()">{{ 'EVALUATION.ADD_FILTER' | translate }}</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col my-3 d-flex  justify-content-end">
          <div class="dropdown dropdown-bhp-export">
            <div class="dropdown-container-input" [ngClass]="!userHasFilter ? 'disabled' : ''" data-toggle="dropdown"
              aria-expanded="false">
              <div class="d-flex align-items-center">
                <img class="dropdown-arrow mr-2"
                  src="{{ !userHasFilter ? 'assets/icons/downloadDarkOutlined-disabled.svg' : 'assets/icons/downloadDarkOutlined.svg' }}" />
                <label [ngClass]="!userHasFilter ? 'disabled-export' : ''">{{ 'EVALUATION.EXPORT' | translate
                  }}</label>
              </div>
              <img class="dropdown-arrow"
                src="{{ !userHasFilter ? 'assets/icons/arrowDropdownOutlined-disabled.svg' : 'assets/icons/arrowDropdownOutlined.svg' }}" />
            </div>

            <ul class="dropdown-menu">
              <li class="dropdown-item" *ngIf="compliance.pdf" (click)="exportAs()">{{ 'EVALUATION.IMAGE' | translate
                }}</li>
              <li class="dropdown-item" *ngIf="results" (click)="excelDownload()">{{ 'GENERAL.EXCEL' | translate }}
              </li>
              <li class="dropdown-item" *ngIf="compliance.pdf" (click)="downloadKendoPDF()">{{
                'EVALUATION.PDF_DOCUMENT' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngIf="userHasFilter">
        <div class="row">
          <h1 class="section-title col-md-6"> {{ "CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE" | translate }} </h1>
          <div [ngClass]="!noDataFound ? 'active-refresh' : 'inactive-refresh'"
            class="justify-content-end col-md-6 refresh-box" (click)="onRefreshClick(noDataFound)">
            <img *ngIf="!noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-active.svg" />
            <img *ngIf="noDataFound" src="assets/ph-bhp-evaluation/icon-refresh-inactive.svg" />
            <span>{{ 'CONFIGURE.FILTERS.REFRESH' | translate }}</span>
          </div>
        </div>

        <ng-container *ngFor="let result of results; let i = index">
          <div class="col-12 chartContainer mb-2">
            <lib-ph-bhp-bar-chart #chart [isAdjustableHeight]="isAdjustableHeight" [isDesktop]='isDesktop'
              *ngIf="userHasFilter" (onSeriesClick)="onSeriesClick($event, i)" [majorUnit]="25"></lib-ph-bhp-bar-chart>
            <div class="no-data-box" *ngIf="result.noDataFound && userHasFilter">
              <div class="no-data-filters justify-content-start d-flex">
                <div class="no-data-title"
                  *ngFor="let dataSet of result?.resultChart?.chartOptions.series || []; let j = index;">
                  <div class="filter-box" [ngClass]="'filter-box-'+dataSet.filterNum">
                  </div>
                  <span class="filter-box-text">{{ dataSet.filterName}}</span>
                </div>
              </div>
              <div class="no-data-message">
                <div class="d-flex justify-content-end" *ngIf="!result.noDataFound && userHasFilter">
                  <p class="sub-steps-legend">{{ 'EVALUATION.RELEVANT_LEGEND' | translate }}</p>
                </div>
                <div class="no-data-textDiv" *ngIf="result.noDataFound && userHasFilter">
                  <span class="no-data-text">{{ 'CONFIGURE.FILTERS.NO_DATA_FOUND' | translate
                    }}</span>
                </div>
                <div class="no-data-textDiv" *ngIf="result.noDataFound && !userHasFilter">
                  <span class="no-data-text">{{ 'CONFIGURE.FILTERS.NO_FILTER_FOUND' | translate
                    }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 gridContainer" *ngIf="userHasFilter">
            <bd-light-table [gridData]="result.gridData || [] " [pageInfo]="pageInfo" [fields]="result.fields"
              [isEvaluationTable]="isEvaluationTable" [chartType]="'filter'" [NAifEmpty]="true"
              [multiSelectText]="multiSelectText"></bd-light-table>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<lib-ph-bhp-pdf-compliance-multi-filter-check #compliance
  [class.isMobile]='!isDesktop'></lib-ph-bhp-pdf-compliance-multi-filter-check>